import React from "react";
import { Card } from "../core/Card";
import { Icon } from "../core/Icon";

export const CATEGORY_ICON_FALLBACK = "briefcase";

export function CategoryCard({ icon, label, count, onClick }) {
  const [hover, setHover] = React.useState(false);
  return (
    <Card interactive padding="md" onClick={onClick}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <div style={{ display: "flex", alignItems: "center", gap: "var(--space-3)" }}>
        <span style={{
          width: 44, height: 44, flex: "0 0 auto", borderRadius: "var(--radius-md)",
          background: hover ? "var(--hive-a20)" : "var(--surface-raised)",
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          color: hover ? "var(--hive-ink)" : "var(--text-muted)",
          transition: "background-color var(--duration-base) var(--ease-out), color var(--duration-base) var(--ease-out)",
        }}>
          <Icon name={icon || CATEGORY_ICON_FALLBACK} size={22} />
        </span>
        <div style={{ minWidth: 0 }}>
          <h3 style={{
            fontFamily: "var(--font-display)", fontWeight: "var(--weight-bold)",
            fontSize: "var(--text-base)", color: "var(--text-body)",
            lineHeight: "var(--leading-tight)",
          }}>{label}</h3>
          {count != null && (
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-xs)", color: "var(--text-subtle)", marginTop: 3 }}>
              {count} specialties
            </p>
          )}
        </div>
      </div>
    </Card>
  );
}
